import { render, staticRenderFns } from "./Sentences.vue?vue&type=template&id=036621e3&scoped=true&"
import script from "./Sentences.vue?vue&type=script&lang=js&"
export * from "./Sentences.vue?vue&type=script&lang=js&"
import style0 from "./Sentences.vue?vue&type=style&index=0&id=036621e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036621e3",
  null
  
)

export default component.exports